import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    container: {
        fontVariant: [
            "tabular-nums"
        ],
        flexShrink: 0
    }
});
export default stylesheet;
